import React, { useEffect, useState } from "react";
import { Button, Spin, Tooltip } from "antd";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import SectionHeader from "../../components/global/SectionHeader";

import "./AddTask.css";
import Layout from "../../components/global/layout";
import ApiClient from "../../methods/api/apiClient";
import { BsArrowLeftSquare } from "react-icons/bs";

const Addtask = () => {
  const query = new URLSearchParams(window.location.search);
  const paramValue = query.get("id");
  const userid = localStorage.getItem("USERID");
  const history = useNavigate();
  const [loading, setloading] = useState(false);
  let tl = localStorage.getItem("tl");
  const initial = {
    expectedminutes: "",
    expectedhours: "",
    taskName: "",
    assignDateAndTime: "",
    expected_time: "",
    description: "",
    project: paramValue,
    employee: userid,
    addedBy: userid,
    assignMembersByTl: "",
  };
  const [form, setform] = useState([initial]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [memberList, SetmemberList] = useState([]);

  useEffect(() => {
    getEmployeeList();
  }, []);

  const handlechange = (e, index) => {
    const field = [...form];
    setform([...form], (field[index][e.target.name] = e.target.value));
  };


  const handlechangeByTL = (e, index) => {
    console.log('hello');
    const selected = Array.from(e.target.selectedOptions, (option) => option.value);
    setSelectedOptions(selected);
    console.log(selected);
    
    const field = [...form];
  console.log(field)
  console.log(e.target.name);
  
    setform([...form], (field[index][e.target.name] = e.target.value));
  }





  const backbutton = () => {
    history(-1);
  };
  const handlesubmit = (e) => {
    e.preventDefault();
    
    ApiClient.post(`task`, form)
      .then((res) => {
        if (res.success == true) {
          history(-1);
          notification.success({ message: "Task Added Successfully" });
        } else {
        }
      })
      .catch((err) => {
        notification.error({ message: "Some error Occurred.Please try again" });
      });
  };

  const getEmployeeList = (e) => {
    let data = {
      // sortBy: "asc",
      // page: 1,
      // count: 100000,
      // search: "",
    id:  paramValue
    };
    ApiClient.allApi(`getProjectMembers`, data).then((res) => {
      if (res.success) {
        SetmemberList(res.data.members);
      } else {
      }
    });
  };

  const addmore = () => {
    const newdata = initial;
    setform([...form, newdata]);
  };
  const remove = (i, e) => {
    e.preventDefault();
    const myformdata = [...form];
    myformdata.splice(i, 1);
    setform(myformdata);
  };

  let currentDate = new Date().toJSON().slice(0, 10);

  return (
    <Layout>
      <div>
        <div>
          <div>
            <div className="main-wrapper">
              <div className="navbar-bg" />
            </div>
            <div className="main-content">
               <div className="headings">
                          <div className="d-flex align-items-center gap-3">
                            <Tooltip title="Back Button">
                              <p onClick={backbutton} className="pointer text-white  fs-3">
                                <BsArrowLeftSquare />
                              </p>
                            </Tooltip>
                            <SectionHeader title="Add Tasks" />
                          </div>
                        </div>
              {/* <div className="d-flex align-items-center justify-content-between headings">
                <SectionHeader title="Add Tasks" />
                <Tooltip title="Add Tasks"> */}
                  {/* <Button
                    type="primary"
                    onClick={backbutton}
                    icon={<i class="fa fa-backward" aria-hidden="true"></i>}
                    size={"large"}
                    shape="circle"
                    className="btn btn-primary profile"
                  /> */}
                {/* </Tooltip>
              </div> */}
              <div className="profile_section_name">
                <section className="section m-0">
                  <div className="">
                    <Spin spinning={loading}>
                      <form
                        className="mt-0 p-3"
                        onSubmit={(e) => handlesubmit(e)}
                      >
                        {form.map((item, index) => (
                          <div className=" p-0 mt-0 mb-4">
                            {index == 0 ? null : (
                              <div>
                                <h5 className="d-inline">
                                  {index == 0
                                    ? null
                                    : "Task" + " " + (index + 1)}
                                </h5>{" "}
                                <button
                                  type="button"
                                  style={{ float: "right" }}
                                  onClick={(e) => remove(index, e)}
                                  className="btn btn-danger"
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </div>
                            )}
                            <div className="row mt-3">
                              <div className="col-md-6">
                                <div className="project-wrapper">
                                  <label className="control-label">
                                    Task Name <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    required
                                    placeholder="Task Name"
                                    className="form-control"
                                    name="taskName"
                                    value={item.taskName}
                                    onChange={(e) => handlechange(e, index)}
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="project-wrapper">
                                  <label className="control-label">
                                    Assign Date{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    required
                                    placeholder="Assign Date"
                                    type="date"
                                    className="form-control"
                                    min={currentDate}
                                    name="assignDateAndTime"
                                    value={item.assignDateAndTime}
                                    onChange={(e) => handlechange(e, index)}
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="project-wrapper">
                                  <label className="control-label">
                                    Expected hours{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <select
                                    className="form-control"
                                    name="expectedhours"
                                    value={item.expectedhours}
                                    onChange={(e) => handlechange(e, index)}
                                    required
                                  >
                                    <option value="">Expected hours...</option>
                                    <option value="00 hour">00 hour</option>
                                    <option value="01 hour">01 hour</option>
                                    <option value="02 hour">02 hour</option>
                                    <option value="03 hour">03 hour</option>
                                    <option value="04 hour">04 hour</option>
                                    <option value="05 hour">05 hour</option>
                                    <option value="06 hour">06 hour</option>
                                    <option value="07 hour">07 hour</option>
                                    <option value="08 hour">08 hour</option>
                                    <option value="09 hour">09 hour</option>
                                    <option value="10 hour">10 hour</option>
                                    <option value="11 hour">11 hour</option>
                                    <option value="12 hour">12 hour</option>
                                    <option value="13 hour">13 hour</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="project-wrapper">
                                  <label className="control-label">
                                    Expected minutes{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <select
                                    className="form-control"
                                    name="expectedminutes"
                                    value={item.expectedminutes}
                                    onChange={(e) => handlechange(e, index)}
                                    required
                                  >
                                    <option value="">Expected minutes...</option>
                                    <option
                                      disabled={item.expectedhours == "00 hour"}
                                      value="00 minute"
                                    >
                                      00 minute{" "}
                                    </option>
                                    <option value="05 minute">05 minute </option>
                                    <option value="10 minute">10 minute </option>
                                    <option value="15 minute">15 minute </option>
                                    <option value="20 minute">20 minute </option>
                                    <option value="25 minute">25 minute </option>
                                    <option value="30 minute">30 minute </option>
                                    <option value="35 minute">35 minute </option>
                                    <option value="40 minute">40 minute </option>
                                    <option value="45 minute">45 minute </option>
                                    <option value="50 minute">50 minute </option>
                                    <option value="55 minute">55 minute </option>
                                  </select>
                                </div>
                              </div>

                              {tl === "true" ? (
                                <>
                                  <div className="col-md-6">
                                    <div className="project-wrapper">
                                      <label className="control-label">
                                        Select Employee{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <br />
                                      <select
                                        className="form-control"
                                        name="employee"
                                        value={item.employee}
                                        onChange={(e) => handlechangeByTL(e, index)}
                                      >
                                          <option value=''disabled>
                                            Select member
                                            </option>
                                        {memberList.map((item, index) => (
                                          
                                          <option key={index} value={item.id}>
                                            {item.fullName}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-12">
                              <div className="project-wrapper">
                                <label className="control-label">
                                  Stories <span className="text-danger">*</span>
                                </label>
                                <textarea
                                  placeholder="Stories"
                                  required
                                  className="form-control"
                                  name="description"
                                  value={item.description}
                                  onChange={(e) => handlechange(e, index)}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                        <button
                          type="primary"
                          className="btn btn-primary mt-1 ms-0"
                          htmlType="submit"
                        >
                          Submit
                        </button>

                        <button
                          className="btn btn-success mt-1"
                          onClick={(e) => addmore()}
                          style={{ float: "right" }}
                          type="button"
                        >
                          Add More
                        </button>
                      </form>
                    </Spin>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default Addtask;
